import { render, staticRenderFns } from "./group_standard_group_item.vue?vue&type=template&id=abcc8816&scoped=true&"
import script from "./group_standard_group_item.vue?vue&type=script&lang=js&"
export * from "./group_standard_group_item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abcc8816",
  null
  
)

export default component.exports